import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

import AddBoxIcon from "@mui/icons-material/AddBox";
import ViewListIcon from "@mui/icons-material/ViewList";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import SimpleTable from "./SimpleTable";

const emptySearchData = {
  VehicleNo: "",
  TripID: "",
  TripDateView: "",
};

const TripTable = ({
  headers,
  rows = [],

  selectedTrip,

  onSelectTrip,

  onView,

  onAdd,

  onManage,
}) => {
  const selectedTripId = selectedTrip?.VehicleID;
  const [searchData, setSearchData] = useState(emptySearchData);

  useEffect(() => {
    setSearchData(emptySearchData);
  }, [rows]);

  const filteredRows = useMemo(() => {
    return rows.filter((val) =>
      Object.keys(searchData).every(
        (key) =>
          searchData[key] === "" ||
          val[key]
            ?.toString()
            .toLowerCase()
            .includes(searchData[key].toString().toLowerCase())
      )
    );
  }, [rows, searchData]);

  const handleSearchData = (event, field) => {
    setSearchData((prevData) => ({ ...prevData, [field]: event.target.value }));
  };

  return (
    <>
      <Typography
        sx={{
          mb: 1.5,
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        Select Trip to Add / Manage Load
      </Typography>

      <SimpleTable
        headers={headers}
        data={filteredRows}
        selectedId={selectedTripId}
        onSelect={onSelectTrip}
        onView={onView}
        searchData={searchData}
        onSearchChange={handleSearchData}
        minWidth={1280}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", md: "center" }}
        spacing={2}
        sx={{ mt: 2 }}
      >
        <Typography
          sx={{
            fontSize: 13,
            color: "#6b7280",
            fontWeight: 600,
          }}
        >
          Showing {filteredRows.length} Trip{filteredRows.length !== 1 ? "s" : ""}
        </Typography>

        <Stack direction="row" spacing={1}>
          <IconButton
            disabled
            sx={{
              border: "1px solid #dce3ef",
              borderRadius: "4px",
              width: 36,
              height: 36,
            }}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>

          <Button
            variant="contained"
            sx={{
              minWidth: 40,
              height: 36,
              boxShadow: "none",
            }}
          >
            1
          </Button>

          <IconButton
            disabled
            sx={{
              border: "1px solid #dce3ef",
              borderRadius: "4px",
              width: 36,
              height: 36,
            }}
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="flex-end"
        spacing={2}
        sx={{ mt: 2 }}
      >
        <Button
          variant="contained"
          startIcon={<AddBoxIcon />}
          disabled={!selectedTrip}
          onClick={onAdd}
          className="btn btn-primary margin-normal"
        >
          Add Load
        </Button>

        <Button
          variant="contained"
          startIcon={<ViewListIcon />}
          disabled={!selectedTrip}
          onClick={onManage}
          className="btn btn-primary margin-normal"
          sx={{
            minWidth: 180,
          }}
        >
          Manage Load
        </Button>
      </Stack>
    </>
  );
};

export default TripTable;